import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import Button from 'components/Button';
import SubHeader from 'components/SubHeader';
import Profile from './Profile';
import LastLogin from './LastLogin';
import NotificationPreferences from './NotificationPreferences';
import FooterBar from 'components/FooterBar';
import useAuth from 'customHook/useAuth'
import { useMutation } from '@apollo/client';
import { UPDATE_STAFF_INFO_BY_STAFF_ID } from 'graphql/service';
import {
  Content,
  ContentColumn,
  Container,
} from 'components/BookingMain/styles';
import { debouncedErrorMessage } from 'utils/messageUtil';
import { message } from 'antd';

const AccountProfile = () => {

  const { userId, profileData } = useAuth()
  const records = useMemo(() => {
    return profileData?.lastLoginRecords || [
      {
        loginDateTime: new Date().toISOString(),
        device: "Unknown",
        ipAddress: "127.0.0.1",
        location: "Unknown"
      },
      {
        loginDateTime: new Date().toISOString(),
        device: "Unknown",
        ipAddress: "127.0.0.1",
        location: "Unknown"
      },
      {
        loginDateTime: new Date().toISOString(),
        device: "Unknown",
        ipAddress: "127.0.0.1",
        location: "Unknown"
      },
      {
        loginDateTime: new Date().toISOString(),
        device: "Unknown",
        ipAddress: "127.0.0.1",
        location: "Unknown"
      },
    ]
  }, [profileData])

  const [updateProfile, { loading: updateProfileLoading }] = useMutation(UPDATE_STAFF_INFO_BY_STAFF_ID, {
    onCompleted: (data) => {
      message.success('Update successfully')
    },
    onError: (error) => {
      debouncedErrorMessage(error.message)
    }
  })

  const handleSaveChanges = () => {
    if (updateProfileLoading) return

    updateProfile({
      variables: {
        userId,
        input: {

        }
      }
    })
  }

  return (
    <>
      <Helmet>
        <title>Account Profile - Rook Hotel PMS</title>
        <meta name="description" content="Account Profile - Rook Hotel PMS" />
      </Helmet>
      <SubHeader>
        <div className="title">
          ACCOUNT PROFILE
        </div>
        <div className="buttonContainer">
          <Button
            mainPage
            success
            onClick={handleSaveChanges}
            data-loading={updateProfileLoading}
            additionalstyle={`
                width: 112px;
              `}
          >
            {updateProfileLoading? null : "Save Changes"}
          </Button>
        </div>
      </SubHeader>
      <Content
        additionalstyle={`
          margin-top: 100px;
        `}
      >
        <ContentColumn>
          <Container>
            <Profile />
          </Container>
          <Container>
            <LastLogin records={records} />
          </Container>
        </ContentColumn>
        <ContentColumn>
          <Container>
            <NotificationPreferences scan={profileData?.scan || {}} />
          </Container>
        </ContentColumn>
      </Content>
      <FooterBar />
    </>
  );
}

export default AccountProfile;
